export const ActionTypes = {
    UPDATE_PRIORITIZED: "UPDATE_PRIORITIZED_REQUEST",
    UPDATE_PRIORITIZED_SUCCESS: "UPDATE_PRIORITIZED_SUCCESS",
    UPDATE_PRIORITIZED_FAILURE: "UPDATE_PRIORITIZED_FAILURE",
}